import Component from "vue-class-component";
import Vue from "Vue";

@Component
export default class SkeletonSmall extends Vue {
}



// WEBPACK FOOTER //
// ./src/shared/components/Skeleton/SkeletonSmall/SkeletonSmall.ts